@if (!(ap | async)) {
  <span>Loading...</span>
}


<div class="full-page grid flex-column flex-nowrap gap-4 justify-content-start align-content-center">
  <div class="full-page-content grid flex-row flex-nowrap justify-content-between align-content-center gap-4" style="flex: 0 0 30%; max-height: 30%;">
    <div class="header area separate col-8 grid flex-column flex-nowrap justify-content-start align-content-center">
      @if ((areas | async ); as a) {
        <div class="flex-auto grid flex-row align-content-center">
          <div class="pad flex-auto">{{ (recovery || a?.T2?.recoveryMode) ? 'R' : ((express || !a?.T2?.inUse) ? 'X' : a?.T2?.occupancy)}}</div>
          <div class="pad flex-auto">{{ a?.T2T1?.occupancy}}</div>
          <div class="pad flex-auto">{{ recovery ? 'R' : ((express || !a?.T1?.inUse) ? 'X' : a?.T1?.occupancy)}}</div>
          <div class="pad flex-auto">{{ a?.T1T0?.occupancy}}</div>
          <div class="pad flex-auto">{{ recovery ? 'R' : a?.T0?.occupancy}}</div>
        </div>
      }
      <div class="flex-auto grid flex-row align-content-center">
        <div class="pad flex-auto">
          <div class="pad-btn" [ngClass]="{'express-mode': express}">Pt</div>
        </div>
        <div class="pad flex-auto">
          <i class="fa fa-long-arrow-right"></i>
        </div>
        <div class="pad flex-auto">
          <div class="pad-btn" [ngClass]="{'express-mode': express}">Re</div>
        </div>
        <div class="pad flex-auto">
          <i class="fa fa-long-arrow-right"></i>
        </div>
        <div class="pad flex-auto">
          <div class="pad-btn">Ac</div>
        </div>
      </div>
    </div>
    <div class="header area total col-2 grid flex-column flex-nowrap justify-content-start align-content-center">
      <div class="flex-auto grid flex-row align-content-center">
        <div class="pad flex-auto">{{ recovery ? 'R' : (totalCars | async) }}</div>
      </div>
      <div class="flex-auto grid flex-row align-content-center">
        <div class="pad flex-auto">
          <div class="pad-btn">T</div>
        </div>
      </div>
    </div>
    <div class="header area extra col-2 grid flex-column justify-content-around align-content-center" [ngClass]="{'br1':1==brigadier, 'br2':2==brigadier, 'br3':3==brigadier}">
      @if (0!=brigadier) {
        <div class="flex-none btn-wrapper grid flex-row justify-content-center align-content-center">
          <button mat-raised-button color="primary" type="button" class="pad-btn flex-auto" [ngClass]="{'pad-btn-checked': multiSelect}" (click)="showMultiSelect($event)">
            <mat-icon svgIcon="MINIVAN" class="minivan car-icon"></mat-icon>
            <mat-icon svgIcon="BREAK" class="break car-icon"></mat-icon>
          </button>
        </div>
      }
      @if (0!=brigadier) {
        <div class="flex-none btn-wrapper grid flex-row justify-content-center align-content-center">
          <button mat-raised-button type="button" class="pad-btn flex-auto" [ngClass]="{'express-btn': express}" (click)="toggleExpress()">
            EXPRESS
          </button>
        </div>
      }
    </div>
  </div>

  <div class="full-page-content grid flex-row flex-nowrap justify-content-between align-content-center gap-4" style="flex: 0 0 70%; max-height: 70%;">
    <div class="area body-area board col-8 grid flex-column flex-nowrap justify-content-start align-content-center">
      <ng-template #tooltipContent  let-name="name" let-area="area">
        <table>
          <thead>
            <tr>
              <th>License plate</th>
              <th>Merk</th>
              <th>Model</th>
              <th>Color</th>
              <th>Company</th>
              @if ('T0' === name) {
                <th>Assigned to</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (car of area; track car) {
              <tr>
                <td>{{car.licensePlate}}</td>
                <td>{{car.properties?.merk}}</td>
                <td>{{car.properties?.model}}</td>
                <td>{{car.properties?.color}}</td>
                <td>
                  @if (-1 !== car.carFeatures.indexOf('UNITAX')) {
                    <i>UT</i>
                  }
                  @if (-1 !== car.carFeatures.indexOf('AUTOTAX')) {
                    <i>AL</i>
                  }
                  @if (-1 !== car.carFeatures.indexOf('TWALTER')) {
                    <i>TW</i>
                  }
                </td>
                @if ('T0' === name) {
                  <td>{{car.assignedTo ? car.assignedTo : ' '}}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </ng-template>
      @for (f of ['TAXI', 'BREAK', 'MINIVAN']; track f) {
        <div [ngClass]="['area-content']" class="flex-auto grid flex-row flex-nowrap justify-content-around align-content-center">
          <div  class="pad" style="flex: 0 0 20%;" >
            <display-area [type]="f" area="T2" [present]="hasFeatures( allFeatures | async, $any(f), 'T2')" (click)="op2.toggle($event)"></display-area>
            <p-popover #op2 class="car-tooltip">
              <ng-container *ngTemplateOutlet="tooltipContent; context: {area: getAllCars(allFeatures | async, $any(f), ['T2'])}"></ng-container>
            </p-popover>
          </div>
          <div class="pad" style="flex: 1 1 20%;"></div>
          <div class="pad" style="flex: 0 0 20%;" >
            <display-area [type]="f" area="T1"  [present]="hasFeatures( allFeatures | async, $any(f), 'T1')" [inApproach]="hasFeatures( allFeatures | async, $any(f), 'T2T1')" (click)="op1.toggle($event)"></display-area>
            <p-popover #op1 class="car-tooltip">
              <ng-container *ngTemplateOutlet="tooltipContent; context: {area: getAllCars(allFeatures | async, $any(f), ['T2T1','T1'])}"></ng-container>
            </p-popover>
          </div>
          <div class="pad" style="flex: 1 1 20%;"></div>
          <div class="pad" style="flex: 0 0 20%;" >
            <display-area [type]="f" area="T0"  [present]="hasFeatures( allFeatures | async, $any(f), 'T0')" [inApproach]="hasFeatures( allFeatures | async, $any(f), 'T1T0')" (click)="op0.toggle($event)"></display-area>
            <p-popover #op0 class="car-tooltip">
              <ng-container *ngTemplateOutlet="tooltipContent; context: {area: getAllCars(allFeatures | async, $any(f), ['T1T0','T0']), name: 'T0'}"></ng-container>
            </p-popover>
          </div>
        </div>
      }
    </div>

    @if (multiSelect) {
      <div class="area body-area buttons col-4 grid flex-column flex-nowrap justify-content-start align-content-center gap-5"
        [ngClass]="{'br1':1==brigadier, 'br2':2==brigadier, 'br3':3==brigadier}">
        <div class="flex-auto grid flex-row justify-content-center gap-5">
          <div class="flex-auto grid flex-column justify-content-center gap-5">
            <button mat-button-toggle type="button" class="pad-btn flex-auto" [ngClass]="{'checked': multiFeature['BREAK']}" (click)="toggleFeature($event, 'BREAK')">
              <mat-icon svgIcon="BREAK" class="mat-icon break car-icon"></mat-icon>
            </button>
            <button mat-button-toggle type="button" class="pad-btn flex-auto" [ngClass]="{'checked': multiFeature['MINIVAN']}" (click)="toggleFeature($event, 'MINIVAN')">
              <mat-icon svgIcon="MINIVAN" class="mat-icon minivan car-icon"></mat-icon>
            </button>
          </div>
          <div class="flex-auto grid flex-column justify-content-center gap-5">
            <button type="button" class="pad-btn flex-auto" [ngClass]="{'checked': multiFeature['AUTOTAX']}" (click)="toggleFeature($event, 'AUTOTAX')">
              <span class="btn-letter">A</span>
            </button>
            <button type="button" class="pad-btn flex-auto" [ngClass]="{'checked': multiFeature['UNITAX']}" (click)="toggleFeature($event, 'UNITAX')">
              <span class="btn-letter">U</span>
            </button>
            <button type="button" class="pad-btn flex-auto" [ngClass]="{'checked': multiFeature['TWALTER']}" (click)="toggleFeature($event, 'TWALTER')">
              <span class="btn-letter">W</span>
            </button>
          </div>
        </div>
        @if ((0 < selectedFeatures.length)) {
          <div class="flex-auto grid flex-column justify-content-center">
            <button mat-raised-button type="button" class="pad-btn btn-ok flex-auto" [ngStyle]="{'width': '100%'}" (click)="confirmMultiSelect($event)">OK</button>
          </div>
        }
        @if ((0 == selectedFeatures.length)) {
          <div class="flex-auto grid flex-column justify-content-center">
            <button mat-raised-button type="button" class="pad-btn btn-ok-disabled flex-auto" [ngStyle]="{'width': '100%'}">OK</button>
          </div>
        }
      </div>
    }

    @if (!multiSelect) {
      <div class="area body-area calls col-4 grid flex-column flex-nowrap justify-content-start align-content-center gap-3"
        [ngClass]="{'br1':1==brigadier, 'br2':2==brigadier, 'br3':3==brigadier}">
        @for (r of (requests | async); track r) {
          <div class="flex-none grid flex-row justify-content-start gap-2 flex-nowrap" [ngStyle]="{'width':'50%'}"
            [ngClass]="{'br1': r?.brigadier === 1, 'br2': r?.brigadier === 2, 'br3': r?.brigadier === 3}">
            @if (!r.inT0) {
              <i class="fa fa-phone flex-none" (click)="uncallRequest($event, r)"></i>
            }
            @if (r.inT0) {
              <i class="fa fa-thumbs-up flex-none" (click)="uncallRequest($event, r)"></i>
            }
            @if (r.featureRequested && r.featureRequested.indexOf('BREAK') > -1) {
              <mat-icon svgIcon="BREAK" class="mat-icon break car-icon flex-none"></mat-icon>
            }
            @if (r.featureRequested && r.featureRequested.indexOf('MINIVAN') > -1) {
              <mat-icon svgIcon="MINIVAN" class="mat-icon minivan car-icon flex-none"></mat-icon>
            }
            @if (!r.featureRequested || (r.featureRequested.indexOf('BREAK') === -1 && r.featureRequested.indexOf('MINIVAN') === -1)) {
              <mat-icon svgIcon="TAXI" class="mat-icon taxi car-icon flex-none"></mat-icon>
            }
            @if (r.featureRequested && r.featureRequested.indexOf('AUTOTAX') > -1) {
              <span class="btn-letter flex-none" >A</span>
            }
            @if (r.featureRequested && r.featureRequested.indexOf('UNITAX') > -1) {
              <span class="btn-letter flex-none" >U</span>
            }
            @if (r.featureRequested && r.featureRequested.indexOf('TWALTER') > -1) {
              <span class="btn-letter flex-none" >W</span>
            }
            @if (!r.featureRequested || (r.featureRequested.indexOf('TWALTER') === -1 && r.featureRequested.indexOf('UNITAX') === -1 && r.featureRequested.indexOf('AUTOTAX') === -1)) {
              <span class="btn-letter flex-none" >X</span>
            }
            <span fxFlexFill></span>
          </div>
        }
      </div>
    }
  </div>
</div>
